export default __webpack_public_path__ + "static/NIST-1e8ead9a08001dbf0d45caa8b4066302.svg";